export default {
  inclusions: {
    order: [
      'variants.variant.external_identifier', 'variants.product.external_identifier',
      'variants.product.media', 'variants.product.categories', 'variants.variant.option_values.option',
      'variants.modifiers.modifier.external_identifier', 'variants.modifiers.modifiers_group.external_identifier',
      'city', 'stock', 'customer', 'delivery_address', 'statuses.status', 'statuses.user', 'payments',
      'statuses_progress', 'deliver_at_local', 'promocode',
    ].join(','),
  },

  dashboard: {
    url: process.env.VUE_APP_DASHBOARD_URL,
  },
}
